import { isEmpty } from 'lodash';

import { storeAppDispatch } from './GlobalState/Store';
import { setPlayerLogout } from './GlobalState/UserReducer';


/**
 * Class to manage user data; it will be saved on Login and deleted on Logout
 */
export class User {

    appName = 'hive_poc';

    // User session data
    authName = undefined;
    serviceLoginName = undefined;
    // Shows petition signing and current balance obtaining methods
    session = undefined;

    // Current balance
    userBalance = 0;

    // Callback to refer to successful login
    callbackServerUserData = undefined;

    getName() {
        return this.authName;
    }

    login(callback) {
        const ualButton = document.querySelector(".ual-button-gen");
        ualButton.click();

        this.callbackServerUserData = callback;
    }

    isLogged() {
        // console.log("is logged: ", this.session);
        const auth = !isEmpty(this.authName) && !isEmpty(this.session);
        return auth;
    }

    logout() {
        console.log("Logout");
        this.authName = undefined;
        this.session = undefined;

        storeAppDispatch(setPlayerLogout());

        if (this.callbackServerUserData !== undefined) {
            this.callbackServerUserData();
        }
    }

    // UserService init called 
    init() {

    }

    static new() {
        if (!User.instance) {
            User.instance = new User();
        }

        return User.instance;
    }
}

export const UserService = User.new();